import { Message } from 'semantic-ui-react';
import styled from 'styled-components';

export default styled(Message)`
	text-align: center;
`;
